import { createContext, ReactNode, useState } from 'react'

export const SelectTabContext = createContext({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setSelectedTabIndex: (i: number) => {
        return
    },
    selectedTabIndex: 0,
})

type SelectTabProviderProps = { children: ReactNode; initialTabIndex: number }

export const SelectTabProvider = ({ children, initialTabIndex }: SelectTabProviderProps) => {
    const [selectedTabIndex, setSelectedTabIndex] = useState(initialTabIndex)
    return (
        <SelectTabContext.Provider
            value={{
                selectedTabIndex,
                setSelectedTabIndex,
            }}
        >
            {children}
        </SelectTabContext.Provider>
    )
}
